import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getDayOfTheWeek } from '../../utils/dates';
import { Title } from '../shop-info/styles';
import { TimeList, Time, Day, TimeVal, Wrapper } from './styles';
import { sortDays, getHoursString, isValid } from './helpers';

/**
 * Display a list of opening times for a shop or service. Highlight
 * the current day
 */
const OpeningTimes = ({ data = {}, title = 'Opening hours' }) => {
  /**
   * We use useEffect and useState for the setting of the day because
   * React expects the Rehydration state to be the same as the build-time
   * state. If the client loads the page on a different day to the build
   * then the states will be different. The text can be reconciled, but
   * DOM attributes (including style classes) are not. This means that
   * the build day is highlighted, and the current day is not.
   *
   * useEffect runs only on the client, so the correct style will be applied
   */
  const [today, setToday] = useState(null);
  useEffect(() => {
    setToday(getDayOfTheWeek());
  }, []);

  if (Object.keys(data).length === 0) return null;

  return <DayList today={today} data={data} title={title} />;
};

export const DayList = ({ today, data = {}, title = null }) => (
  <Wrapper>
    {title && <Title>{title}</Title>}
    <TimeList>
      {Object.keys(data)
        .sort(sortDays)
        .map((day) => data[day])
        .filter(isValid)
        .map((day) => (
          <Time
            key={day.label}
            $today={day.label === today}
            data-testid={day.label}
          >
            <Day>{day.label}:</Day>{' '}
            <TimeVal>{day.closed ? 'Closed' : getHoursString(day)}</TimeVal>
          </Time>
        ))}
    </TimeList>
  </Wrapper>
);

DayList.propTypes = {
  /** Displayed above the opening times */
  title: PropTypes.string,
  data: PropTypes.object,
  today: PropTypes.string,
};

OpeningTimes.propTypes = {
  /** Displayed above the opening times */
  title: PropTypes.string,
  data: PropTypes.object,
};

export default OpeningTimes;
